import { getFirstCharacter } from './getFirstCharacter';

export const getInitials = (human: { firstName?: string; lastName?: string }): string => {
  return `${getFirstCharacter(human.firstName ?? '')}${getFirstCharacter(human.lastName ?? '')}`;
};
